exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VlCalendarMonth .flatpickr-calendar {\n  width: 100%;\n}\n.VlCalendarMonth .flatpickr-days {\n  width: 100%;\n}\n.VlCalendarMonth .dayContainer {\n  width: 100%;\n  min-width: none;\n  max-width: none;\n}\n.VlCalendarMonth .flatpickr-rContainer {\n  width: 100%;\n}\n.VlCalendarMonth .flatpickr-day > div {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  border-radius: 50%;\n  height: 0.4rem;\n  width: 0.4rem;\n  background-color: gray;\n}\n.vlEventsList {\n  height: 40vh;\n  overflow-y: auto;\n}", ""]);

// exports
